import { render, staticRenderFns } from "./splitR.vue?vue&type=template&id=5d08f53a&scoped=true"
import script from "./splitR.vue?vue&type=script&lang=js"
export * from "./splitR.vue?vue&type=script&lang=js"
import style0 from "./splitR.vue?vue&type=style&index=0&id=5d08f53a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d08f53a",
  null
  
)

export default component.exports